module.exports = __webpack_public_path__ + "static/media/kit_robotArm.190f8b34.png";